import {PlayerColor} from '@colonist/game-states'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {MapValidator} from '../core/map/MapValidator'

export abstract class MechanicValidator {
    protected readonly playerValidators: Map<PlayerColor, PlayerValidator>
    protected readonly mapValidator: MapValidator

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator) {
        this.playerValidators = new Map()
        for(const playerState of playerValidators) {
            this.playerValidators.set(playerState.color, playerState)
        }

        this.mapValidator = mapValidator
    }
}
